import React from 'react'
import styles from './index.module.less'
import { Image, message } from 'antd'
const data = [
  { id: 1, src: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png', link: "" },
  { id: 2, src: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png', link: "https://4x.ant.design/components/image-cn/#API" },
  { id: 3, src: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png', link: "https://4x.ant.design/components/image-cn/#API" },
  { id: 4, src: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png', link: "https://4x.ant.design/components/image-cn/#API" },
  { id: 5, src: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png', link: "https://4x.ant.design/components/image-cn/#API" },
  { id: 6, src: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png', link: "https://4x.ant.design/components/image-cn/#API" },
  { id: 7, src: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png', link: "https://4x.ant.design/components/image-cn/#API" },
  { id: 8, src: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png', link: "https://4x.ant.design/components/image-cn/#API" },
  { id: 9, src: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png', link: "https://4x.ant.design/components/image-cn/#API" },
  { id: 10, src: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png', link: "https://4x.ant.design/components/image-cn/#API" },
  { id: 11, src: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png', link: "https://4x.ant.design/components/image-cn/#API" },
  { id: 12, src: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png', link: "https://4x.ant.design/components/image-cn/#API" },
  { id: 13, src: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png', link: "https://4x.ant.design/components/image-cn/#API" },
  { id: 14, src: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png', link: "https://4x.ant.design/components/image-cn/#API" },
  { id: 15, src: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png', link: "https://4x.ant.design/components/image-cn/#API" },
  { id: 16, src: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png', link: "https://4x.ant.design/components/image-cn/#API" },
]
export default function Media() {
  return (
    <div className={styles.cont}>
      <span className={styles.big_title}>合作媒体</span>
      <div className={styles.media}>
        {
          data.map(i => (
            <Image
              onClick={i.link === '' ? () => { message.info('空') } : () => { window.open(i.link, '_blank') }}
              key={i.id}
              src={i.src}
              preview={false}
              placeholder={true}
            />
          ))
        }
      </div>
    </div>
  )
}
